import theme from "@theme/index";

const EmailLayoutStyles = {
  contentRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 5,
    maxHeight: "100%",
    overflowY: "scroll",
    px: 3,
    py: 4,
  },
  drawerHeading: {
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.borderColor.dark}`,
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
    p: 2,
  },
  drawerRoot: {
    borderRight: `1px solid ${theme.palette.borderColor.dark}`,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: "100%",
    maxWidth: { lg: "500px", md: "420px", sm: "350px" },
  },
  labelStyles: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    flexWrap: "wrap",
    gap: 1,
  },
  root: {
    borderTop: `1px solid ${theme.palette.borderColor.dark}`,
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    height: "calc(100vh - 306px)",
    overflow: "hidden",
    width: "100%",
  },
};

export default EmailLayoutStyles;
